import { db } from './db'
import * as firebase from 'firebase'
const axios = require('axios');
var ID = function () {
    return '_' + Math.random().toString(36).substr(2, 9);
};
export const addArticle = (title, country, content, continent, markers, adventure, desc, image, date) => {
    const data = {
        title, country, content, continent, markers, desc, image, comments: [], date
    }
    if (adventure) {
        data.adventure = adventure
    }

    var collectionRef = db.collection("articles").doc();

    collectionRef.set({
        ...data, ownId: collectionRef.id
    })
    return collectionRef.id
}

export const updateArticle = (data, ownId) => {
    return db.collection('articles').doc(ownId).update(data)
}

export const deleteArticle = (ownId) => db.collection('articles').doc(ownId).delete()
export const getAllArticles = async () => {
    const results = await db.collection('articles').get()
    return results.docs.map(doc => doc.data())
}

export const getAllContinents = async () => {
    const results = await db.collection('continents').get()
    return results.docs.map(doc => doc.data())
}

export const getAllCountries = async () => {
    const results = await db.collection('countries').get()
    return results.docs.map(doc => doc.data())
}

export const addCountry = async (data) => {
    return db.collection('countries').add(data)
}

export const addAdventure = async (title, desc, content, image) => {
    var collectionRef = db.collection("adventures").doc();

    collectionRef.set({
        title, content, desc, image, ownId: collectionRef.id
    })
    return collectionRef.id
}

export const updateAdventure = (data, ownId) => {
    return db.collection('adventures').doc(ownId).update(data)
}

export const deleteAdventure = (ownId) => db.collection('adventures').doc(ownId).delete()

export const getAllAdventures = async () => {
    const results = await db.collection('adventures').get()
    return results.docs.map(doc => doc.data())
}

export const uploadImage = async (file) => {
    const name = ID();
    var storageRef = firebase.storage().ref();

    // Create a reference to 'mountains.jpg'
    var ref = storageRef.child(name + '.jpg');
    const snap = await ref.put(file)
    const url = await snap.ref.getDownloadURL()
    return { url, path: snap.metadata.fullPath }

}

export const addComment = async (id, comments) => {
    return db.collection('articles').doc(id).update({ comments })
}


// -------

export const addToolsBox = async (title, content) => {
    var collectionRef = db.collection("toolsbox").doc();

    collectionRef.set({
        title, content, ownId: collectionRef.id
    })

    return collectionRef.id
}

export const updateToolsBox = async (data, ownId) => {
    return db.collection('toolsbox').doc(ownId).update(data)
}

export const deleteToolBox = (ownId) => db.collection('toolsbox').doc(ownId).delete()
export const getAllToolsBox = async () => {
    const results = await db.collection('toolsbox').get()
    return results.docs.map(doc => doc.data())
}

// -------
export const updateMyData = (content, fb, insta, desc, url) => {
    return db.collection('me').doc("1").update({ content, fb, insta, desc, url })
}

export const getMyData = async () => {
    const results = await db.collection('me').doc("1").get()
    return results.data()
}


/// 

export const getFlag = async (country) => {
    const r = await axios.get(`https://restcountries.eu/rest/v2/alpha/${country}`)
    return { country, url: r.data.flag }
}



export const login = async (mail, pwd) => {
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function () {
            // Existing and future Auth states are now persisted in the current
            // session only. Closing the window would clear any existing state even
            // if a user forgets to sign out.
            // ...
            // New sign-in will be persisted with session persistence.
            return firebase.auth().signInWithEmailAndPassword(mail, pwd)
        })
}

export const updateBgColor = (bgColor) => {
    return db.collection('me').doc("1").update({ bgColor })
}

export const updateTextColor = (textColor) => {
    return db.collection('me').doc("1").update({ textColor })
}